import React, { useState } from 'react';

const ImageUploadSection = ({ editUploadedImages, handleFileUpload }) => {
    const [isUploading, setIsUploading] = useState(false);
    const hasImage = editUploadedImages && editUploadedImages.length > 0 && editUploadedImages[0]?.src;

    const handleFileChange = (event) => {
        setIsUploading(true);
        handleFileUpload(event);
        // Reset loading state after a short delay
        setTimeout(() => setIsUploading(false), 1000);
    };

    return (
        <div className="image-section">
            {hasImage ? (
                <img
                    src={editUploadedImages[0].src}
                    style={{ filter: "blur(1.5px)" }}
                    alt="Uploaded image"
                />
            ) : (
                <div 
                    style={{
                        width: '100%',
                        height: '6rem', // Reduced from 8rem
                        backgroundColor: '#f3f4f6',
                        border: '2px dashed #d1d5db',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <div style={{ textAlign: 'center', color: '#6b7280' }}>
                        <i className="fas fa-image" style={{ fontSize: '1.5rem', marginBottom: '0.375rem', display: 'block' }} /> {/* Reduced from 2rem and 0.5rem */}
                        <span style={{ fontSize: '0.75rem' }}>No image uploaded</span> {/* Reduced from 0.875rem */}
                    </div>
                </div>
            )}
            <div className="overlay">
                <label htmlFor="image-upload" className="upload-label" style={{ pointerEvents: isUploading ? 'none' : 'auto' }}>
                    {isUploading ? (
                        <>
                            <i className="fas fa-spinner fa-spin icon" />
                            <span style={{ marginLeft: '0.5rem', fontSize: '0.75rem' }}> {/* Reduced from 0.875rem */}
                                Uploading...
                            </span>
                        </>
                    ) : (
                        <>
                            <i className="fas fa-plus icon" />                          
                        </>
                    )}
                    <input
                        id="image-upload"
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        disabled={isUploading}
                    />
                </label>
            </div>
        </div>
    );
};

export default ImageUploadSection; 